import { CHAT_USER } from "@chesshotel/constants";
import React from "react";
import Chat from "../../components/common/chat";
import { chatCreated, useGamePlay } from "../../redux/gamePlay";
import { useUser } from "../../redux/user";
// import { websocket } from "../../services/websocket";
import { GamePlayWs } from "../../services/wsOutRoutes";
import { Profanity } from "@2toad/profanity";

const profanity = new Profanity({languages: ["en", "ru", "de", "fr", "es", "it", "pt", "ko"]});
  

function sendChat(msg: string) {
  msg = profanity.censor(msg);
  GamePlayWs.sendChat(msg);
  chatCreated({ msg, type: CHAT_USER });
}

export default function GameChat({
  autoFocusInput = true,
}: {
  autoFocusInput?: boolean;
} = {}) {
  const { chatMessages, opponent } = useGamePlay();
  const { username } = useUser();
 


  const chatProps = {
    chatMessages,
    username,
    opponentUsername: opponent.username,
    sendChat,
    autoFocusInput,
  };

  return <Chat {...chatProps} />;
}
